import React, { Component } from "react";
import Link from "next/link";
import { fetchSingleBlog } from "../../../src/store/actions";
import { BlogCard } from "../../../src/components/layouts/partials";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from "react-share";
import { iconByExtension } from "../../../src/utils/helpers";

class GovernmentJobsDetails extends Component {
  static async getInitialProps(ctx) {
    try {
      let slug_ori = ctx.query.slug[0];
      let slug = slug_ori.split("-");
      let id = slug[slug.length - 1];
      const blog = await ctx.store.dispatch(fetchSingleBlog({ id }));
      return {
        title:
          blog && blog.data
            ? `Rojgarisanjal ${
                blog.data.data.meta_title || blog.data.data.title
              }`
            : "Rojgarisanjal Blog",
        meta_desc: blog.data.data.meta_desc || blog.data.data.short_desc,
        meta_img: blog.data.data.image,
        keywords: blog.data.data.keywords,
        showFooter: true,
        blog: blog && blog.data ? blog.data.data : {},
        relatedBlogs: blog.data.related,
        slug: slug_ori,
      };
    } catch (e) {
      console.log(e.response);
    }
  }
  render() {
    const { blog, relatedBlogs, slug } = this.props;
    return (
      <div>
        <div className="tr-breadcrumb bg-image section-before jobs-listing">
          <div className="container">
            <div className="breadcrumb-info text-center">
              <h2>{"Government Jobs".toUpperCase()}</h2>

              <ul className="job-meta tr-list list-inline">
                <li>
                  <Link href={"/"}>
                    <a href={"/"}>
                      <i className="fas fa-home" />
                      {"Rojgari Sanjal"}
                    </a>
                  </Link>
                  &nbsp;&nbsp;
                  <Link href={"/government-jobs"}>
                    <a href={"/government-jobs"}>
                      <i className="fas fa-chevron-right" />
                      {"Government Jobs"}
                    </a>
                  </Link>
                  &nbsp;&nbsp;
                  <i className="fas fa-chevron-right" />
                  <span style={{ color: "#ccc" }}>{blog.title}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="job-list-container">
          <div className="container-fluid">
            <div className="row justify-content-md-center">
              <div className="col-lg-10">
                <div className="blog-detail-image-box">
                  <h1>
                    {blog.title}{" "}
                    {blog.blog_files.length > 0 ? (
                      <small style={{ fontSize: 16 }}>
                        <a
                          href=""
                          onClick={(e) => {
                            e.preventDefault();
                            document
                              .querySelector("#attached_files")
                              .scrollIntoView({
                                behavior: "smooth",
                                block: "center",
                                inline: "nearest",
                              });
                          }}
                        >
                          {" "}
                          <u> ({blog.blog_files.length} file(s) attached)</u>
                        </a>
                      </small>
                    ) : (
                      ""
                    )}
                  </h1>
                  {blog.image ? (
                    <div style={{ overflow: "hidden", marginBottom: 8 }}>
                      <img
                        style={{
                          objectFit: "cover",
                          width: "100%",
                          height: "100%",
                        }}
                        src={`${blog.image}`}
                        onError={(e) => {
                          e.target.src =
                            "https://www.worldloppet.com/wp-content/uploads/2018/10/no-img-placeholder.png";
                        }}
                        alt=""
                      />
                    </div>
                  ) : null}
                  <div className="mt-4">
                    <div dangerouslySetInnerHTML={{ __html: blog.desc }}></div>
                  </div>
                  {blog.blog_files && blog.blog_files.length > 0 ? (
                    <div id="attached_files" className="md-5">
                      <hr />

                      <h5>
                        <u>
                          {blog.blog_files.length} files(s) attached with this
                          job. (click to download)
                        </u>
                      </h5>
                      <br />

                      {blog.blog_files.map((item, key) => {
                        const extension = item.file.split(".").pop();
                        return (
                          <a
                            key={key}
                            target="_blank"
                            href={item.file}
                            style={{
                              display: "inline-block",
                              width: 70,
                              marginRight: 20,
                            }}
                          >
                            <span style={{ fontSize: 12 }}>
                              {iconByExtension(extension)}(
                              {extension.toUpperCase()} File)
                            </span>
                          </a>
                        );
                      })}
                    </div>
                  ) : null}
                  <hr />
                  <FacebookShareButton
                    quote={blog.title}
                    // hashtag={"#FreeJobPostRojgarisanjal"}
                    url={`https://www.rojgarisanjal.com/blogs/details/${slug}`}
                  >
                    <FacebookIcon size={40} round />
                  </FacebookShareButton>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <TwitterShareButton
                    quote={blog.title}
                    // hashtag={"#FreeJobPostRojgarisanjal"}
                    url={`https://www.rojgarisanjal.com/job/detail/${slug}`}
                  >
                    <TwitterIcon size={40} round />
                  </TwitterShareButton>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <LinkedinShareButton
                    quote={blog.title}
                    // hashtag={"#FreeJobPostRojgarisanjal"}
                    url={`https://www.rojgarisanjal.com/job/detail/${slug}`}
                  >
                    <LinkedinIcon size={40} round />
                  </LinkedinShareButton>
                </div>
              </div>

              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-12">
                    <h3>Related Government Jobs</h3>
                    <hr />
                  </div>
                  {relatedBlogs.map((item, key) => {
                    return (
                      <BlogCard
                        isGovernmentJobs={true}
                        key={key}
                        column={"col-lg-3 col-md-4"}
                        {...item}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GovernmentJobsDetails;
